import get from 'lodash/get';
import { PREFIX } from './reducer';

export const getStatusContact = (state) => ({
  hasError: Boolean(get(state, `${PREFIX}.error`, false)),
  isLoading: Boolean(get(state, `${PREFIX}.status`, false)),
  isSuccess: Boolean(get(state, `${PREFIX}.isSuccess`, false)),
});
